// extracted by mini-css-extract-plugin
export default {"register":"Register_register__TqgAL"};